module.exports = __webpack_public_path__ + "img/chart-no-data.67b5805d.png";